<template>
  <va-create-layout>
    <content-image-form :title="title" :item="item"></content-image-form>
  </va-create-layout>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },
};
</script>
